<template>
    <Detail v-if="data" :logo-on-click="logoOnClick" show-footer>
        <template v-slot:header>
            <div class="row">
                <div class="col col-6">
                    <h4>{{ $t("buyer") }}</h4>
                    <h2>{{ data.name }}</h2>
                    <h3>{{ $filters.upper($t("organization_id")) }}: {{ data.ico }}</h3>
                </div>
                <div id="suppliers" class="col col-2 d-none d-md-block ">
                    <h4>{{ $t("supplier", 2) }}</h4>
                    <h2 class="numeric">
                        {{ formatInteger(data.suppliers_count) }}
                    </h2>
                </div>
                <div id="period" class="col col-6 col-md-4">
                    <h4>{{ $t("period") }}</h4>
                    <h2 class="numeric">
                        {{ $filters.formatDate(data.start_date, "M/YYYY") }}-{{ $filters.formatDate(data.end_date, "M/YYYY")
                        }}
                    </h2>
                </div>
            </div>
        </template>

        <template v-slot:header_small>
            <div class="row no-gutters">
                <div class="col col-6 col-md-8">
                    <h2>{{ data.name }}</h2>
                </div>
                <div id="period" class="col col-6 col-md-4">
                    <h2 class="numeric">
                        {{ $filters.formatDate(data.start_date, "M/YYYY") }} - {{
                            $filters.formatDate(data.end_date, "M/YYYY")
                        }}
                    </h2>
                </div>
            </div>
        </template>

        <template v-slot:menu>
            <teaser-ad :name="data.name" :ico="data.ico" :flags-total="data.flags_total"></teaser-ad>
        </template>

        <template v-slot:content>

            <color-bubble variant="dark" ratio="half">
                <template v-slot:icon>
                    <b-icon icon="wallet" />
                </template>
                <template v-slot:heading>{{ $t("overview.sum.short", [formatNumber(data.suppliers_total)]) }}</template>
                <template v-slot:description>{{ $t("overview.sum.long") }}</template>
            </color-bubble>



            <color-bubble variant="beige" @click="goToBlog()"
                class="clickable-color-bubble d-none d-md-block color_dark_important">
                <template v-slot:icon>
                    <b-icon icon="newspaper" />
                </template>
                <template v-slot:heading>Co Kontrola umí a k čemu je dobrá?</template>
                <template v-slot:description>
                    Blog&nbsp;
                    <img :src="`${publicPath}double_arrow.svg`">
                </template>
            </color-bubble>


            <color-bubble variant="beige" @click="order(data.name, data.ico, 'lite')"
                class="clickable-color-bubble d-none d-md-block color_dark_important">
                <template v-slot:icon>
                    <b-icon icon="search" />
                </template>
                <template v-slot:heading>{{ $t("overview.flags.other") }}</template>
                <template v-slot:description>
                    {{ $t("button.order") }}&nbsp;
                    <img :src="`${publicPath}double_arrow.svg`">

                </template>

            </color-bubble>

            <h5 class="mt-5 mb-3" id="flags_carousel_section">
                {{ $t("overview.carousel.title") }}
            </h5>

            <!-- Exemplary flags -->
            <FlagRowTeaser :flags="data.carousel"/>

            <h5 class="mt-5 mb-3" id="flags_section">
                {{ $t("overview.flags.title") }}
            </h5>

            <RisksTable :flags="data.flags" :version="version" />

            <teaser-ad class="d-md-none" :name="data.name" :ico="data.ico" :flags-total="data.flags_total"></teaser-ad>
        </template>
    </Detail>
</template>

<script>
import Detail from "@/views/layouts/Detail.vue";
import ColorBubble from "@/components/ColorBubble.vue";
import TeaserAd from "@/components/TeaserAd.vue";
import formattersMixin from "@/plugins/formattersMixin.js";
import RisksTable from "@/components/RisksTable.vue";
import RiskLevelDumpling from "@/components/RiskLevelDumpling.vue";
import analysisMixin from "@/plugins/analysisMixin.js";
import riskMixin from "@/plugins/riskMixin.js";
import FlagRowTeaser from "@/components/FlagRowTeaser.vue";
import { Carousel } from "bootstrap";


import { CONFIG } from "@/config.js"

export default {
    props: {
        hash: { required: true }
    },
    name: "teaser",
    components: { Detail, ColorBubble, RisksTable, TeaserAd, RiskLevelDumpling, FlagRowTeaser },
    mixins: [formattersMixin, analysisMixin, riskMixin],
    mounted: function () {
        this.isBusy = true;
        this.loadData()
            .then(() => {
                this.$store.dispatch("setCurrentAnalysis", this.data)
                this.$root.$emit("set-page-title", this.$t("titleDetail", { name: this.data.name }))

                this.fixLongSlideDescription(0)
            })
            .catch((e) => console.log(e))
            .finally((this.isBusy = false));
    },
    data: function () {
        return {
            data: null,
            isBusy: false,
            nav: {
                flags: {
                    scrollTo: { el: "#flags_section" },
                    label: this.$t("nav.risks")
                }
            },
            carouselDescriptionExpanded: false,
            fixedDescriptions: [],
            longDescriptions: [],
            activeCarouselSlide: 0
        };
    },
    computed: {
        version: () => "teaser",
        publicPath: function () {
            return import.meta.env.BASE_URL
        }
    },
    watch: {
        activeCarouselSlide: function () {
            this.fixLongSlideDescription(this.activeCarouselSlide)
        }
    },
    methods: {
        goToBlog: function () {
            window.open("https://blog.econlab.cz/datlab-kontrola-najdeme-kostlivce-ve-skrini-vaseho-uradu/", "_blank");
        },
        loadData: function () {
            return new Promise((resolve, reject) => {
                var self = this;

                var params = {
                    format: "json",
                    teaser_hash: this.hash
                };

                this.$store.getters.api
                    .get(`${this.version}/${this.hash}`, { params: params })
                    .then((response) => {
                        self.data = response.data;
                        resolve();
                    })
                    .catch((e) => {
                        reject(e);
                        self.data = null;
                    });
            });
        },
        logoOnClick: function () {
            window.location.href = CONFIG.apiBaseUrl
        },
        fixLongSlideDescription: function (n) {
            if (this.fixedDescriptions.includes(n)) {
                return
            }

            var nodes = document.getElementsByClassName('carousel-description')
            var el = nodes[n]

            var divHeight = el.offsetHeight
            var lineHeight = 24 //parseInt(document.defaultView.getComputedStyle(el, null).getPropertyValue("line-height"))

            var lines = divHeight / lineHeight;
            if (lines > 2) {
                this.longDescriptions.push(n)
            }

            this.fixedDescriptions.push(n)
        }
    }
};
</script>

<style lang="scss">
@use "@/scss/custom";
@use "@/scss/utils";

.premium_column {
    margin-top: 23px;
    padding-left: 10px;
}

#numeric_column {
    font-family: custom.$font-family-base;
    font-size: 14px;
}

.risk_table {
    margin-bottom: 30px;
}

.last_column {
    padding-right: 20px;
}

.blog_link {
    color: white;
}

#menu {
    margin-bottom: 50px;

    button {
        text-align: left;
        background-color: custom.$background-light;
        padding: 0.6rem 1.5rem;
        padding-right: 0;

        &:hover {
            background-color: custom.$light;
        }

        &[disabled] {
            background-color: transparent;
        }

        .premium_label {
            float: right;
        }
    }
}

#flags-carousel {
    margin-bottom: 25px;

    .carousel-indicators {
        margin-bottom: -15px;
        align-items: center;

        li {
            width: 5px;
            height: 5px;
            border-width: 0px;
            border-radius: 5px;
            background-color: custom.$dark;

            &.active {
                border: 1px solid custom.$dark;
                background-color: transparent;
            }

            &:focus {
                outline: none;
                box-shadow: none;
            }
        }
    }

    .carousel-control-prev,
    .carousel-control-next {
        width: 30px;
    }

    .carousel-control-prev-icon {
        background-image: url("/chevron-left.svg");
    }

    .carousel-control-next-icon {
        background-image: url("/chevron-left.svg");
        transform: rotate(180deg);
    }

    .carousel-item::before {
        content: "";
        width: 30px;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        background: #f8f8f8;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .carousel-item::after {
        content: "";
        width: 30px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        background: #f8f8f8;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
    }

    .carousel-item {
        position: relative;
        padding-left: 50px;
        padding-right: 50px;

        .carousel-slide-content {
            height: 100px;
            background: #f8f8f8;
            border-radius: 8px;
            font-size: 16px;
            padding: 15px 20px;
            text-align: left;
        }

        .carousel-caption {
            position: relative;
            color: custom.$body-color;
            margin: 0;
            left: 0;
            right: 0;
            bottom: 0;
            padding: 0;
        }

        .carousel-header {
            font-size: 105%;
            margin-bottom: 5px;
        }

        .carousel-description a {
            display: none;
        }

        .carousel-slide-content.long {
            .carousel-description {
                position: relative;
                height: 50px;
                overflow: hidden;

                a {
                    position: absolute;
                    display: inline;
                    bottom: 2px;
                    right: 0;
                    padding: 0 5px 0 40px;
                    background-image: linear-gradient(to right, rgba(0, 0, 0, 0), #f8f8f8 40%);
                }
            }

            &.expanded {
                height: auto;

                .carousel-description {
                    height: auto;
                    overflow: unset;

                    a {
                        padding: 0;
                        background-image: none;
                        position: relative;
                        display: block;
                    }
                }
            }
        }
    }
}
</style>
